export default "__VITE_ASSET__CJSYg6Uj__"